// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import animated from 'animate.css'
import VueCoreVideoPlayer from 'vue-core-video-player'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import jquery from 'jquery'
Vue.prototype.$ = jquery



// h5
import { Collapse, CollapseItem, Icon, Form, Field, Swipe, SwipeItem, Tab, Tabs, Overlay, CellGroup, Toast } from 'vant'
import 'vant/lib/index.css'
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Icon)
Vue.use(Form)
Vue.use(Field)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Overlay)
Vue.use(CellGroup)
Vue.use(Toast)

Vue.use(VueFullPage)
Vue.use(animated)
Vue.use(VueCoreVideoPlayer)
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js